<script>
import moment from "moment";

export default {
  name: "PartOfDayVisitCheckBox",
  props: {
    id: {
      type: String,
      required: true
    },
      service: {
          type: Object,
          required: true
      },
    name: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      default() {
        return 0
      }
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      checkbox: this.value ?? 0
    }
  },
  watch: {
    checkbox(value) {
        if (value) {
            this.service.visits[this.index].originalStartTime = this.service.visits[this.index].startTime;
            this.service.visits[this.index].originalEndTime = this.service.visits[this.index].endTime;
            this.service.visits[this.index].startTime = moment("00:00","HH:mm").format(this.service.meta.JsTimeFormat)
            this.service.visits[this.index].endTime = moment("23:59", "HH:mm").format(this.service.meta.JsTimeFormat);
            if (value && this.service.visits[this.index].part_of_day === undefined) {
              this.service.visits[this.index].part_of_day = 'Anytime (12 - 12 AM)'; // Set your default value here
            }
        } else {
            this.service.visits[this.index].startTime = this.service.visits[this.index].originalStartTime
            this.service.visits[this.index].endTime = this.service.visits[this.index].originalEndTime
            this.service.visits[this.index].originalStartTime = null
            this.service.visits[this.index].originalEndTime = null
        }
      this.$emit('input', value)
    },
      value(value){
        if (value){
            this.service.visits[this.index].is_all_day_event=value;
        }
      },
      deep: true,
      immediate: true
  },
}
</script>

<template>
  <label class="container-checkbox" :for="id">
    No Specified Time
    <input type="checkbox" ref="checkbox" v-model="checkbox" :true-value="1"
           :false-value="0" :name="name" :id="id" class="not_specified">
    <span class="checkmark"></span>
  </label>
</template>

<style scoped>

</style>